export default {
  client: {
    action: "Importer des clients",
    title: "Importer des clients",
    mapDescription:
      "Choisissez le champ que remplit chacune de vos colonnes. Les colonnes laissées sur Ignorer ne sont pas importées.",
    fieldsGroup: "Champs du client",
    checkingDescription:
      "Vérification de chaque ligne selon les champs du client.",
    reviewDescription:
      "Certaines lignes doivent être corrigées avant de pouvoir être importées.",
    dropDescription:
      "Ajoutez un fichier CSV de vos clients. Rien n'est envoyé à Invup avant que vous appuyiez sur Importer.",
    serverDescription:
      "Vos lignes ont été vérifiées de nouveau lorsque vous avez appuyé sur Importer.",
    confirmTitle_one: "Importer 1 client",
    confirmTitle_other: "Importer {{count, number}} clients",
    confirmCreates_one: "Cela crée 1 client dans votre organisation.",
    confirmCreates_other:
      "Cela crée {{count, number}} clients dans votre organisation.",
    confirmLeftOut_one: "La ligne comportant des problèmes est exclue.",
    confirmLeftOut_other:
      "Les {{count, number}} lignes comportant des problèmes sont exclues.",
    confirmIrreversible: "Une importation ne peut pas être annulée.",
    successTitle: "Clients importés avec succès",
    successBody_one: "1 client a été ajouté à votre liste de clients.",
    successBody_other:
      "{{count, number}} clients ont été ajoutés à votre liste de clients.",
    noneTitle: "Aucun client importé",
    allFailedBody_one: "La ligne a échoué, donc aucun client n'a été ajouté.",
    allFailedBody_other:
      "Les {{count, number}} lignes ont échoué, donc aucun client n'a été ajouté.",
    stoppedBody_one:
      "1 client sur {{total, number}} a été importé avant l'arrêt de l'importation. Il reste dans votre liste de clients.",
    stoppedBody_other:
      "{{count, number}} clients sur {{total, number}} ont été importés avant l'arrêt de l'importation. Ils restent dans votre liste de clients.",
    stoppedBodyNone:
      "L'importation a été arrêtée avant l'importation de tout client.",
    failedBody_one:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté. 1 client sur {{total, number}} a été importé avant l'arrêt, et il reste dans votre liste de clients.",
    failedBody_other:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté. {{count, number}} clients sur {{total, number}} ont été importés avant l'arrêt, et ils restent dans votre liste de clients.",
    failedBodyNone:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté, avant l'importation de tout client.",
    failedAdvice:
      "Désolé pour le désagrément. Vérifiez votre liste de clients avant de réimporter le fichier, afin que les mêmes clients ne soient pas ajoutés deux fois.",
    lastDescription:
      "La plus récente importation de clients de votre organisation.",
    failuresDescription:
      "Ces lignes n'ont pas été importées. Corrigez-les dans votre fichier, puis importez-les de nouveau.",
    unknownBody:
      "La connexion a été interrompue avant la réponse d'Invup, donc on ne sait pas si votre importation a démarré. Vérifiez son état avant de réessayer, afin de ne pas importer les mêmes clients deux fois.",
    progressCloseHint:
      "Vous pouvez fermer cette fenêtre. L'importation se poursuit, et rouvrir Importer des clients en affiche la progression.",
    runningDescription:
      "Une importation de clients est en cours pour votre organisation.",
    othersTitle_one: "{{name}} importe 1 client",
    othersTitle_other: "{{name}} importe {{count, number}} clients",
    othersTitleAnonymous_one: "Un autre membre importe 1 client",
    othersTitleAnonymous_other:
      "Un autre membre importe {{count, number}} clients",
    stopWritten_one: "1 client sur {{total, number}} a déjà été importé.",
    stopWritten_other:
      "{{count, number}} clients sur {{total, number}} ont déjà été importés.",
    stopKept:
      "Les clients déjà importés restent dans votre liste de clients : l'arrêt ne peut pas les annuler. Les lignes restantes ne sont pas importées.",
    stopNoneWritten: "Aucun client n'a encore été importé.",
    stopNoneKept: "Aucune de ses {{total, number}} lignes ne sera importée.",
    blockedLiveBody:
      "{{name}} importe des clients pour votre organisation. Vous pourrez importer votre fichier lorsque son importation sera terminée.",
    blockedLiveBodyAnonymous:
      "Un autre membre importe des clients pour votre organisation. Vous pourrez importer votre fichier lorsque son importation sera terminée.",
    blockedUnreadableBody:
      "Une importation de clients est déjà en cours pour votre organisation. Réessayez plus tard.",
    importingTitle_one: "Importation de 1 client…",
    importingTitle_other: "Importation de {{count, number}} clients…",
    viewList: "Voir la liste de clients",
  },
  project: {
    action: "Importer des projets",
    title: "Importer des projets",
    mapDescription:
      "Choisissez le champ que remplit chacune de vos colonnes. Les colonnes laissées sur Ignorer ne sont pas importées.",
    fieldsGroup: "Champs du projet",
    checkingDescription:
      "Vérification de chaque ligne selon les champs du projet.",
    reviewDescription:
      "Certaines lignes doivent être corrigées avant de pouvoir être importées.",
    dropDescription:
      "Ajoutez un fichier CSV de vos projets. Rien n'est envoyé à Invup avant que vous appuyiez sur Importer.",
    serverDescription:
      "Vos lignes ont été vérifiées de nouveau lorsque vous avez appuyé sur Importer.",
    confirmTitle_one: "Importer 1 projet",
    confirmTitle_other: "Importer {{count, number}} projets",
    confirmCreates_one: "Cela crée 1 projet dans votre organisation.",
    confirmCreates_other:
      "Cela crée {{count, number}} projets dans votre organisation.",
    confirmLeftOut_one: "La ligne comportant des problèmes est exclue.",
    confirmLeftOut_other:
      "Les {{count, number}} lignes comportant des problèmes sont exclues.",
    confirmIrreversible: "Une importation ne peut pas être annulée.",
    successTitle: "Projets importés avec succès",
    successBody_one: "1 projet a été ajouté à votre liste de projets.",
    successBody_other:
      "{{count, number}} projets ont été ajoutés à votre liste de projets.",
    noneTitle: "Aucun projet importé",
    allFailedBody_one: "La ligne a échoué, donc aucun projet n'a été ajouté.",
    allFailedBody_other:
      "Les {{count, number}} lignes ont échoué, donc aucun projet n'a été ajouté.",
    stoppedBody_one:
      "1 projet sur {{total, number}} a été importé avant l'arrêt de l'importation. Il reste dans votre liste de projets.",
    stoppedBody_other:
      "{{count, number}} projets sur {{total, number}} ont été importés avant l'arrêt de l'importation. Ils restent dans votre liste de projets.",
    stoppedBodyNone:
      "L'importation a été arrêtée avant l'importation de tout projet.",
    failedBody_one:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté. 1 projet sur {{total, number}} a été importé avant l'arrêt, et il reste dans votre liste de projets.",
    failedBody_other:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté. {{count, number}} projets sur {{total, number}} ont été importés avant l'arrêt, et ils restent dans votre liste de projets.",
    failedBodyNone:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté, avant l'importation de tout projet.",
    failedAdvice:
      "Désolé pour le désagrément. Vérifiez votre liste de projets avant de réimporter le fichier, afin que les mêmes projets ne soient pas ajoutés deux fois.",
    lastDescription:
      "La plus récente importation de projets de votre organisation.",
    failuresDescription:
      "Ces lignes n'ont pas été importées. Corrigez-les dans votre fichier, puis importez-les de nouveau.",
    unknownBody:
      "La connexion a été interrompue avant la réponse d'Invup, donc on ne sait pas si votre importation a démarré. Vérifiez son état avant de réessayer, afin de ne pas importer les mêmes projets deux fois.",
    progressCloseHint:
      "Vous pouvez fermer cette fenêtre. L'importation se poursuit, et rouvrir Importer des projets en affiche la progression.",
    runningDescription:
      "Une importation de projets est en cours pour votre organisation.",
    othersTitle_one: "{{name}} importe 1 projet",
    othersTitle_other: "{{name}} importe {{count, number}} projets",
    othersTitleAnonymous_one: "Un autre membre importe 1 projet",
    othersTitleAnonymous_other:
      "Un autre membre importe {{count, number}} projets",
    stopWritten_one: "1 projet sur {{total, number}} a déjà été importé.",
    stopWritten_other:
      "{{count, number}} projets sur {{total, number}} ont déjà été importés.",
    stopKept:
      "Les projets déjà importés restent dans votre liste de projets : l'arrêt ne peut pas les annuler. Les lignes restantes ne sont pas importées.",
    stopNoneWritten: "Aucun projet n'a encore été importé.",
    stopNoneKept: "Aucune de ses {{total, number}} lignes ne sera importée.",
    blockedLiveBody:
      "{{name}} importe des projets pour votre organisation. Vous pourrez importer votre fichier lorsque son importation sera terminée.",
    blockedLiveBodyAnonymous:
      "Un autre membre importe des projets pour votre organisation. Vous pourrez importer votre fichier lorsque son importation sera terminée.",
    blockedUnreadableBody:
      "Une importation de projets est déjà en cours pour votre organisation. Réessayez plus tard.",
    importingTitle_one: "Importation de 1 projet…",
    importingTitle_other: "Importation de {{count, number}} projets…",
    viewList: "Voir la liste de projets",
  },
  expense: {
    action: "Importer des dépenses",
    title: "Importer des dépenses",
    mapDescription:
      "Choisissez le champ que remplit chacune de vos colonnes. Les colonnes laissées sur Ignorer ne sont pas importées.",
    fieldsGroup: "Champs de la dépense",
    checkingDescription:
      "Vérification de chaque ligne selon les champs de la dépense.",
    reviewDescription:
      "Certaines lignes doivent être corrigées avant de pouvoir être importées.",
    dropDescription:
      "Ajoutez un fichier CSV de vos dépenses. Rien n'est envoyé à Invup avant que vous appuyiez sur Importer.",
    serverDescription:
      "Vos lignes ont été vérifiées de nouveau lorsque vous avez appuyé sur Importer.",
    confirmTitle_one: "Importer 1 dépense",
    confirmTitle_other: "Importer {{count, number}} dépenses",
    confirmCreates_one: "Cela crée 1 dépense dans votre organisation.",
    confirmCreates_other:
      "Cela crée {{count, number}} dépenses dans votre organisation.",
    confirmLeftOut_one: "La ligne comportant des problèmes est exclue.",
    confirmLeftOut_other:
      "Les {{count, number}} lignes comportant des problèmes sont exclues.",
    confirmIrreversible: "Une importation ne peut pas être annulée.",
    successTitle: "Dépenses importées avec succès",
    successBody_one: "1 dépense a été ajoutée à votre liste de dépenses.",
    successBody_other:
      "{{count, number}} dépenses ont été ajoutées à votre liste de dépenses.",
    noneTitle: "Aucune dépense importée",
    allFailedBody_one:
      "La ligne a échoué, donc aucune dépense n'a été ajoutée.",
    allFailedBody_other:
      "Les {{count, number}} lignes ont échoué, donc aucune dépense n'a été ajoutée.",
    stoppedBody_one:
      "1 dépense sur {{total, number}} a été importée avant l'arrêt de l'importation. Elle reste dans votre liste de dépenses.",
    stoppedBody_other:
      "{{count, number}} dépenses sur {{total, number}} ont été importées avant l'arrêt de l'importation. Elles restent dans votre liste de dépenses.",
    stoppedBodyNone:
      "L'importation a été arrêtée avant l'importation de toute dépense.",
    failedBody_one:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté. 1 dépense sur {{total, number}} a été importée avant l'arrêt, et elle reste dans votre liste de dépenses.",
    failedBody_other:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté. {{count, number}} dépenses sur {{total, number}} ont été importées avant l'arrêt, et elles restent dans votre liste de dépenses.",
    failedBodyNone:
      "L'importation s'est arrêtée en raison d'une erreur de notre côté, avant l'importation de toute dépense.",
    failedAdvice:
      "Désolé pour le désagrément. Vérifiez votre liste de dépenses avant de réimporter le fichier, afin que les mêmes dépenses ne soient pas ajoutées deux fois.",
    lastDescription: "La dernière importation de dépenses.",
    failuresDescription:
      "Ces lignes n'ont pas été importées. Corrigez-les dans votre fichier, puis importez-les de nouveau.",
    unknownBody:
      "La connexion a été interrompue avant la réponse d'Invup, donc on ne sait pas si votre importation a démarré. Vérifiez son état avant de réessayer, afin de ne pas importer les mêmes dépenses deux fois.",
    progressCloseHint:
      "Vous pouvez fermer cette fenêtre. L'importation se poursuit, et rouvrir Importer des dépenses en affiche la progression.",
    runningDescription:
      "Une importation de dépenses est en cours pour votre organisation.",
    othersTitle_one: "{{name}} importe 1 dépense",
    othersTitle_other: "{{name}} importe {{count, number}} dépenses",
    othersTitleAnonymous_one: "Un autre membre importe 1 dépense",
    othersTitleAnonymous_other:
      "Un autre membre importe {{count, number}} dépenses",
    stopWritten_one: "1 dépense sur {{total, number}} a déjà été importée.",
    stopWritten_other:
      "{{count, number}} dépenses sur {{total, number}} ont déjà été importées.",
    stopKept:
      "Les dépenses déjà importées restent dans votre liste de dépenses : l'arrêt ne peut pas les annuler. Les lignes restantes ne sont pas importées.",
    stopNoneWritten: "Aucune dépense n'a encore été importée.",
    stopNoneKept: "Aucune de ses {{total, number}} lignes ne sera importée.",
    blockedLiveBody:
      "{{name}} importe des dépenses pour votre organisation. Vous pourrez importer votre fichier lorsque son importation sera terminée.",
    blockedLiveBodyAnonymous:
      "Un autre membre importe des dépenses pour votre organisation. Vous pourrez importer votre fichier lorsque son importation sera terminée.",
    blockedUnreadableBody:
      "Une importation de dépenses est déjà en cours pour votre organisation. Réessayez plus tard.",
    importingTitle_one: "Importation de 1 dépense…",
    importingTitle_other: "Importation de {{count, number}} dépenses…",
    viewList: "Voir la liste de dépenses",
    totalHint:
      "Les totaux laissés vides sont calculés à partir du sous-total, des taxes et des frais",
  },
  map: {
    fileSummary_one: "{{fileName}} · 1 ligne",
    fileSummary_other: "{{fileName}} · {{count, number}} lignes",
    requiredLabel: "Obligatoire",
    requiredMapped: "associé",
    requiredMissing: "non associé",
    columnsLabel: "Colonnes :",
    columnCount: "{{imported}} importées · {{skipped}} ignorées",
    headers: {
      column: "Votre colonne",
      mapsTo: "Associée à",
      samples: "Exemples de valeurs",
    },
    selectLabel: "Associée à, pour la colonne {{column}}",
    skip: "Ignorer cette colonne",
    requiredOption: "{{label}} (obligatoire)",
    usedBy: "Utilisé par {{column}}",
    checkedOnSubmit: "Vérifié lorsque vous appuyez sur Importer",
    noValues: "Aucune valeur dans cette colonne",
    unnamedColumn: "Colonne {{n}} (sans nom)",
    blocked: "Associez une colonne à {{fields}} pour continuer.",
  },
  review: {
    checkingTitle: "Vérification de {{count, number}} lignes…",
    checkingProgress:
      "{{checked, number}} lignes vérifiées sur {{total, number}}",
    changeColumns: "Modifier les colonnes",
    summaryTitle_one:
      "{{count, number}} ligne sur {{total, number}} comporte des problèmes",
    summaryTitle_other:
      "{{count, number}} lignes sur {{total, number}} comportent des problèmes",
    summaryBody_one: "1 ligne est prête. Rien n'a encore été importé.",
    summaryBody_other:
      "{{count, number}} lignes sont prêtes. Rien n'a encore été importé.",
    allFailTitle: "Aucune des {{total, number}} lignes ne peut être importée",
    allFailBody:
      "Corrigez les problèmes dans votre fichier, puis choisissez-le de nouveau. Si toutes les lignes échouent de la même façon, vérifiez vos choix de colonnes.",
    stepper: "Ligne à corriger {{index, number}} sur {{count, number}}",
    previous: "Ligne à corriger précédente",
    next: "Ligne à corriger suivante",
    headers: {
      line: "Ligne",
      field: "Champ",
      value: "Valeur",
      problem: "Problème",
    },
    lineLabel: "Ligne {{line, number}}",
    emptyValue: "(vide)",
    wholeRow: "Ligne entière",
    leaveOut_one:
      "L'importation maintenant laisse de côté **1 ligne comportant des problèmes** (ligne {{lines}}). Elle ne sera pas importée.",
    leaveOut_other:
      "L'importation maintenant laisse de côté **{{count, number}} lignes comportant des problèmes** (lignes {{lines}}). Elles ne seront pas importées.",
    moreLines: "{{lines}} et {{count}} autres",
    copyLines: "Copier les numéros de ligne",
    copied: "Numéros de ligne copiés",
    redropConsequence:
      "Si vous choisissez un fichier corrigé dont les colonnes sont inchangées, vos choix de colonnes sont conservés. Sinon, vous les associez de nouveau.",
    chooseCorrected: "Choisir le fichier corrigé",
    serverTitle:
      "Invup a trouvé des problèmes que votre navigateur n'a pas pu vérifier",
    serverBody_one:
      "1 ligne a été rejetée lorsque vous avez appuyé sur Importer, donc rien n'a été importé. Elle est marquée « Détecté à l'importation » ci-dessous.",
    serverBody_other:
      "{{count, number}} lignes ont été rejetées lorsque vous avez appuyé sur Importer, donc rien n'a été importé. Elles sont marquées « Détecté à l'importation » ci-dessous.",
    serverBodyTruncated:
      "Au moins {{count, number}} lignes ont été refusées lorsque vous avez appuyé sur Importer, donc rien n’a été importé. Corrigez ou excluez ces lignes, puis importez de nouveau pour vérifier le reste.",
    foundOnImport: "Détecté à l'importation",
    reason: {
      required: "{{field}} est obligatoire.",
      minLength: "Doit contenir au moins {{min, number}} caractères.",
      maxLength:
        "Doit contenir {{max, number}} caractères ou moins. Cette valeur en compte {{length, number}}.",
      email: "Adresse courriel non valide.",
      countryCode: "Utilisez un code de pays à deux lettres, comme CA ou US.",
      allowedValues: "Cette valeur ne fait pas partie des options acceptées.",
      decimal: "Doit être un nombre avec au plus deux décimales, comme 12.5.",
      decimalMin: "Doit être au moins {{min, number}}.",
      decimalMax: "Doit être au plus {{max, number}}.",
      date: "Doit être une date au format AAAA-MM-JJ.",
      enumValue: "Doit être l'une des valeurs suivantes : {{values}}.",
      boolean: "Utilisez yes, no, true, false, 1 ou 0.",
      emailList: "Chaque élément doit être une adresse courriel valide.",
      emailListTooMany: "Utilisez au plus {{max, number}} adresses courriel.",
      currencyCode:
        "Utilisez un code de devise à trois lettres, comme CAD ou USD.",
      requiredIf:
        '{{field}} est obligatoire lorsque {{other}} est "{{value}}".',
      afterOrEqual: "Doit être égale ou postérieure à {{other}}.",
      duplicateOf:
        "Doublon de la ligne {{line, number}}, qui utilise le même courriel.",
    },
  },
  steps: {
    ariaLabel: "Progression de l'importation",
    file: "Choisir un fichier",
    columns: "Associer les colonnes",
    review: "Vérifier les lignes",
    import: "Importer",
    compact: "Étape {{current}} sur {{total}} : {{label}}",
  },
  drop: {
    choose: "Choisissez un fichier CSV",
    orDrag: "ou glissez-le ici",
    hint: "Jusqu'à {{limit, number}} lignes. La première ligne doit contenir les noms de vos colonnes.",
    dragOver: "Déposez le fichier pour le lire",
    loadingSettings: "Récupération des paramètres d'importation…",
    reading: "Lecture… {{count, number}} lignes jusqu'ici",
    summary_one: "1 ligne · {{columns}}",
    summary_other: "{{count, number}} lignes · {{columns}}",
    columnCount_one: "1 colonne",
    columnCount_other: "{{count, number}} colonnes",
    columnsFound: "Colonnes trouvées",
    moreColumns: "+{{count, number}} de plus",
    chooseAnother: "Choisir un autre fichier",
    mismatchTitle_one:
      "1 ligne a un nombre de colonnes différent de celui de la ligne d'en-tête",
    mismatchTitle_other:
      "{{count, number}} lignes ont un nombre de colonnes différent de celui de la ligne d'en-tête",
    mismatchBody:
      "La première se trouve à la ligne {{line, number}}. Cela signifie souvent que des valeurs contiennent des virgules sans guillemets, ou que ce n'est pas le fichier voulu. Les valeurs manquantes seront traitées comme vides et les valeurs en trop seront ignorées.",
    refused: {
      notCsv:
        "{{fileName}} n'est pas un fichier CSV. Enregistrez-le au format CSV (valeurs séparées par des virgules) depuis votre tableur, puis choisissez-le à nouveau.",
      empty:
        "{{fileName}} est vide. Choisissez un fichier contenant une ligne de noms de colonnes et au moins une ligne en dessous.",
      headerOnly:
        "{{fileName}} contient des noms de colonnes, mais aucune ligne en dessous. Ajoutez au moins une ligne, puis choisissez-le à nouveau.",
      overCap:
        "{{fileName}} contient {{count, number}} lignes, et une importation est limitée à {{limit, number}}. Divisez-le en fichiers plus petits et importez chacun d'eux.",
      unreadable:
        "{{fileName}} n'a pas pu être lu comme un fichier CSV. Vérifiez qu'il a été enregistré au format CSV, puis choisissez-le à nouveau.",
      multiple: "Choisissez un seul fichier à la fois.",
    },
  },
  settingsError: {
    title: "L'importation est indisponible pour le moment",
    body: "Désolé, l'importation n'a pas pu être préparée en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
  },
  submit: {
    keepOpen: "Gardez cette fenêtre ouverte jusqu'à la fin.",
    busy: "Importation…",
    serverError:
      "Désolé, votre importation n'a pas pu démarrer en raison d'une erreur de notre côté. Veuillez réessayer.",
  },
  complete: {
    leftOut_one: "1 ligne que vous avez exclue n'a pas été importée.",
    leftOut_other:
      "{{count, number}} lignes que vous avez exclues n'ont pas été importées.",
  },
  open: {
    loading: "Recherche d'une importation en cours…",
  },
  progress: {
    queuedTitle: "Démarrage de votre importation…",
    queued: "En attente du démarrage de l'importation par Invup.",
    processed: "{{processed, number}} lignes traitées sur {{total, number}}",
    failedSoFar_one: "1 ligne en échec jusqu'ici",
    failedSoFar_other: "{{count, number}} lignes en échec jusqu'ici",
    stop: "Arrêter l'importation",
    unknownTransient: "État momentanément inconnu. Reconnexion…",
    lostTitle: "Connexion perdue",
    lostBody:
      "L'importation se poursuit sur les serveurs d'Invup. La progression affichée est la dernière transmise par Invup.",
    checkFailed:
      "Invup est injoignable. Vérifiez votre connexion, puis réessayez.",
    stopUnconfirmed:
      "Invup n'a pas confirmé si l'importation a été arrêtée. La progression ci-dessous est à jour.",
    announce: "{{percent}} traité",
  },
  stop: {
    title: "Arrêter l'importation",
    confirm: "Arrêter l'importation",
    stopping: "Arrêt en cours…",
    startedBySelf: "Vous avez lancé cette importation.",
    startedBy: "{{name}} a lancé cette importation.",
    startedByAnonymous: "Un autre membre a lancé cette importation.",
    error:
      "Désolé, l'importation n'a pas pu être arrêtée en raison d'une erreur de notre côté. Veuillez réessayer.",
    alreadyFinished:
      "Cette importation était déjà terminée, donc rien n'a été arrêté.",
  },
  result: {
    meta: "Lancée le {{date}} par {{name}}",
    metaAnonymous: "Lancée le {{date}}",
    stoppedSettling:
      "Les lignes en cours d'écriture au moment de l'arrêt peuvent encore être ajoutées pendant quelques secondes.",
    finishedTitle: "Importation terminée",
    stoppedTitle: "Importation arrêtée",
    failedTitle: "Échec de l'importation",
    failedRows_one: "1 ligne a échoué et n'a pas été importée.",
    failedRows_other:
      "{{count, number}} lignes ont échoué et n'ont pas été importées.",
  },
  failures: {
    title: "Lignes en échec",
    summary_one: "1 ligne a échoué",
    summary_other: "{{count, number}} lignes ont échoué",
    summaryBody:
      "Le téléchargement conserve vos colonnes et ajoute le motif dans une dernière colonne. Corrigez les lignes, supprimez cette colonne, puis importez le fichier.",
    range: "{{from}} à {{to}} sur {{total}}",
    previousPage: "Page précédente",
    nextPage: "Page suivante",
    loading: "Chargement des lignes en échec…",
    loadError:
      "Désolé, les lignes en échec n'ont pas pu être chargées en raison d'une erreur de notre côté. Veuillez réessayer.",
    expiredDescription: "Ces lignes n'ont pas été importées.",
    expiredTitle: "Le détail des lignes en échec n'est plus disponible",
    expiredBody_one:
      "Invup conserve le détail des lignes en échec pendant 30 jours après une importation. La ligne en échec de cette importation a dépassé ce délai, elle ne peut donc pas être affichée ni téléchargée.",
    expiredBody_other:
      "Invup conserve le détail des lignes en échec pendant 30 jours après une importation. Les {{count, number}} lignes en échec de cette importation ont dépassé ce délai, elles ne peuvent donc pas être affichées ni téléchargées.",
    downloading: "Téléchargement…",
    downloadError:
      "Désolé, les lignes en échec n'ont pas pu être téléchargées en raison d'une erreur de notre côté. Veuillez réessayer plus tard.",
  },
  blocked: {
    title: "Une autre importation est en cours",
    kept: "Votre fichier et vos choix de colonnes sont conservés tant que cette fenêtre reste ouverte.",
    finishedTitle: "L'autre importation est terminée",
    finishedBody: "Vous pouvez maintenant importer votre fichier.",
  },
  unknown: {
    title: "État de l'importation inconnu",
    check: "Vérifier l'état",
    checking: "Vérification…",
    notStartedTitle: "Votre importation n'a pas démarré",
    notStartedBody: "Rien n'a été importé, et vos lignes sont toujours ici.",
    checkFailed:
      "Désolé, l'état n'a pas pu être vérifié en raison d'une erreur de notre côté. Veuillez réessayer.",
  },
  actions: {
    close: "Fermer",
    tryAgain: "Réessayer",
    cancel: "Annuler",
    continue: "Continuer",
    importRows_one: "Importer 1 ligne",
    importRows_other: "Importer {{count, number}} lignes",
    viewFailedRows: "Voir les lignes en échec",
    importAnother: "Importer un autre fichier",
    downloadFailedRows: "Télécharger les lignes en échec",
    back: "Retour",
  },
};
